import { render, staticRenderFns } from "./SupplierTagsTable.vue?vue&type=template&id=d2c6dc52&scoped=true&"
import script from "./SupplierTagsTable.vue?vue&type=script&lang=js&"
export * from "./SupplierTagsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c6dc52",
  null
  
)

export default component.exports